<form #form="ngForm">

    <div class="modal-header">
        <h4 class="modal-title">Confirm Removal of Deactivation Date</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.close(null)">
            <span aria-hidden="true">&times;</span>
        </button>

    </div>
    <div class="modal-body">
        <p class="font-weight-bold">Please confirm to activate user and removed its current deactivation date.</p>


        <div class="row" style="margin: 0px 5px 0px 5px;">
            <re-alert type="warning" [dismissible]="false">
                This will remove deactivation date {{ deactivationDate.toISOString().split('T')[0] }} for the user.
                Once reactivated, you can change the deactivation date for the user later.
            </re-alert>
        </div>


    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="activate()">Activate User</button>
        <button type="button" class="btn btn-cancel" (click)="close()">Close</button>
    </div>
</form>